import {
    ESIM_ACTIVATION_CODE_ERROR, ESIM_ACTIVATION_CODE_REQUEST, ESIM_ACTIVATION_CODE_SUCCESS, ESIM_ACTIVATION_CODE_RESET,
    ESIM_RETRIGGER_MULTI_RECP_REQUEST,
    ESIM_RETRIGGER_MULTI_RECP_SUCCESS,
    ESIM_RETRIGGER_MULTI_RECP_ERROR,
    SIM_ACTIVATION_STATUS_REQUEST,
    SIM_ACTIVATION_STATUS_SUCCESS,
    SIM_ACTIVATION_STATUS_ERROR,
    SIM_ACTIVATION_SUBMIT_REQUEST,
    SIM_ACTIVATION_SUBMIT_SUCCESS,
    SIM_ACTIVATION_SUBMIT_ERROR
} from "@/actions/simactivation/actionTypes";
export const initialState = {
    esimActivationError: '',
    esimActivationSuccess: '',
    esimActivationLoading: false,
    esimMultiRecpError: '',
    esimMultiRecpSuccess: '',
    esimMultiRecpLoading: false,
    simActivationStatusData: {},
    simActivationSubmitData: {},
    isLoading: false,
    simActivationSubmitError: '',
    esimActStatusLoading: false
};

const simActivationReducer = (state = initialState, action) => {
    switch (action.type) {
        case ESIM_ACTIVATION_CODE_REQUEST:
            return {
                ...state,
                esimActivationLoading: true,
                esimActivationError: '',
                esimActivationSuccess: ''
            };
        case ESIM_ACTIVATION_CODE_SUCCESS:
            return {
                ...state,
                esimActivationLoading: false,
                esimActivationSuccess: 'RETRIEVE_ESIM_ACTIVATION_CODE_SUCCESS'
            };
        case ESIM_ACTIVATION_CODE_ERROR:
            return {
                ...state,
                esimActivationLoading: false,
                esimActivationError: action.error.response?.data?.message,
                esimActivationSuccess: ''
            };
        case ESIM_ACTIVATION_CODE_RESET:
            return initialState;
        case ESIM_RETRIGGER_MULTI_RECP_REQUEST:
            return {
                ...state,
                esimMultiRecpLoading: true,
                esimMultiRecpError: '',
                esimMultiRecpSuccess: ''
            };
        case ESIM_RETRIGGER_MULTI_RECP_SUCCESS:
            return {
                ...state,
                esimMultiRecpLoading: false,
                esimMultiRecpError: '',
                esimMultiRecpSuccess: 'RETRIEVE_ESIM_ACTIVATION_CODE_SUCCESS'
            };
        case ESIM_RETRIGGER_MULTI_RECP_ERROR:
            return {
                ...state,
                esimMultiRecpLoading: false,
                esimMultiRecpError: action.error.response?.data?.message,
                esimMultiRecpSuccess: ''
            };

        case SIM_ACTIVATION_STATUS_REQUEST: return { ...state, isLoading: true, simActivationStatusData: {}, esimActStatusLoading: true }
        case SIM_ACTIVATION_STATUS_SUCCESS: return { ...state, isLoading: false, simActivationStatusData: action.data, esimActStatusLoading: false }
        case SIM_ACTIVATION_STATUS_ERROR: return { ...state, isLoading: false, error: action.error.response?.data?.message || "SIM_ACTIVATION_STATUS_ERROR", esimActStatusLoading: false }

        case SIM_ACTIVATION_SUBMIT_REQUEST: return { ...state, isLoading: true, simActivationSubmitData: {} }
        case SIM_ACTIVATION_SUBMIT_SUCCESS: return { ...state, isLoading: false, simActivationSubmitData: action.data }
        case SIM_ACTIVATION_SUBMIT_ERROR: return { ...state, isLoading: false, simActivationSubmitError: action.error.response?.data?.message || "SIM_ACTIVATION_SUBMIT_ERROR" }

        default:
            return state;
    }
}

export default simActivationReducer;